import {useParams} from 'react-router-dom'
import dayjs from 'dayjs'
import styles from './ProjectAbout.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {useOpen} from 'common/hooks'
import {Box, Button, Modal} from 'common/components'
import {
  ProjectCard,
  ProjectMenu,
  ProjectAboutIndicators,
  ProjectAboutStats,
  VariationForm, VariationDefaultForm, VariationJournalForm,
  useGetProject,
} from '..'

interface VariationsProps {
  project: any
}

export default function ProjectAbout() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)

  const requestUuid = project?.loanRequests?.[0]?.uuid
  return (
    <div className={styles.root}>
      <ProjectCard project={project} imgHeight={280}>
        <ProjectMenu requestUuid={requestUuid} />
      </ProjectCard>
      <div>
        <ProjectAboutIndicators />
        {!false && <Variations project={project} />}
        <ProjectAboutStats requestUuid={requestUuid} />
      </div>
    </div>
  )
}

const Variations = ({project}: VariationsProps) => {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const [isOpenDef, handleOpenDef, handleCloseDef] = useOpen()
  const [isOpenVar, handleOpenVar, handleCloseVar] = useOpen()
  const [isOpenJou, handleOpenJou, handleCloseJou] = useOpen()

  const isDefaulting = ( project.activeDefaultRequest && (project?.activeDefaultRequest?.type as string).toLocaleLowerCase() === 'start' )
  const label = `${!isDefaulting ? 'Start':'Stop'} default`
  return (

    <>
      <Box className={styles.variation} align="center" mb={40}>
        { !!permissions?.includes('default request') &&
        <Button
          // disabled
          className={styles.button}
          variant="secondary"
          onClick={handleOpenDef}
        >
          {label}
        </Button>
        }
        { !!permissions?.includes('variation request') &&
        <Button
          // disabled
          className={styles.button}
          variant="secondary"
          onClick={handleOpenVar}
        >
          Add variations
        </Button>
        }
        { !!permissions?.includes('journal request') &&
          <Button
          // disabled
          className={styles.button}
          variant="secondary"
          onClick={handleOpenJou}
        >
          Journal
        </Button>
      }
      </Box>
      <Modal
        narrow
        title={label}
        width={485}
        open={isOpenDef}
        onCancel={handleCloseDef}
      >
        <VariationDefaultForm projectUuid={project.uuid} 
          type={ !isDefaulting ? 'start' : 'stop' }
          initialValues={!!project?.activeDefaultRequest?.startDate ? ({
            startDate: dayjs(project.activeDefaultRequest.startDate).toDate()
          }) : undefined}
          onClose={handleOpenDef}
        />
      </Modal>
      <Modal
        narrow
        // title={`Variations for project ‘${project.title}’`}
        title="Variation Request"
        width={768}
        open={isOpenVar}
        onCancel={handleCloseVar}
      >
        <VariationForm project={project} />
      </Modal>
      <Modal
        narrow
        title={`Journal`}
        width={485}
        open={isOpenJou}
        onCancel={handleCloseJou}
      >
        <VariationJournalForm projectUuid={project.uuid} onClose={handleCloseJou} />
      </Modal>
    </>
  )
}
